import cn from "classnames";
import BidsFilter from "components/bids/filter";
import * as configs from "components/bids/filter/config";
import Select from "components/shared/select";
import { mergeFilters } from "helpers/reqparams";
import React from "react";

export default class SuitableDistributionBidsFilter extends BidsFilter {
    UNSAFE_componentWillMount() {
        return undefined;
    }

    get tags() {
        const isSelected = (name) => this.filterValue(name);
        return [
            {
                name: "Приоритетный контрагент",
                selected: isSelected("isPriorityCounterparty"),
                show: true,
                onChange: this.mergeFilters.bind(this, {
                    name: "isPriorityCounterparty",
                    value: !isSelected("isPriorityCounterparty"),
                }),
            },
            {
                name: "Обязательный заказ",
                selected: isSelected("isMandatory"),
                show: true,
                onChange: this.mergeFilters.bind(this, { name: "isMandatory", value: !isSelected("isMandatory") }),
            },
            {
                name: "Все заказы вне зависимости от дат",
                selected: isSelected("skipCheckPlanEnterDate"),
                show: true,
                onChange: this.mergeFilters.bind(this, {
                    name: "skipCheckPlanEnterDate",
                    value: !isSelected("skipCheckPlanEnterDate"),
                }),
            },
        ];
    }

    mergeMultipleFilters = (data) => {
        const filters = { ...this.props.filters };
        data.forEach(({ name, value }) => {
            this.mergeCustomFilter(filters, name, value);
        });
        const { mergeParams, params } = this.props;
        const buildFilters = this.buildOdataFilter(filters);
        params.customFilters = filters;
        params.preparedFilter = buildFilters.filter;
        params.queryFilter = buildFilters.query;
        setTimeout(() => {
            mergeFilters(mergeParams, { name: "custom", value: null }, params);
        }, 0);
    };

    resetFilters = (e) => {
        e && e.stopPropagation();
        const { mergeParams, params } = this.props;
        params.customFilters = {};
        params.preparedFilter = {};
        params.queryFilter = {};
        this.setState({
            idInputValue: "",
            emptyMileage: { key: "ge", value: "" },
            outputWithEmptyMileage: { key: "ge", value: "" },
        });
        mergeFilters(mergeParams, { name: "custom", value: null }, params);
    };

    renderPointSelect = (propName) => {
        const filterValue = this.filterValue(`${propName}.id`);
        const props = {
            onChange: ({ name, value }) =>
                this.mergeMultipleFilters([
                    { name: `${name}.id`, value },
                    { name: `${name}.radius`, value: null },
                ]),
            ...configs[propName === "from" ? "fromPointConfig" : "toPointConfig"](filterValue, true),
        };
        return (
            <div className="b-filter__body-cell">
                <Select {...props} />
                {filterValue && this.radiusInput(propName)}
            </div>
        );
    };

    radiusInput = (propName) => {
        const placement = propName === "from" ? "top" : "bottom";
        return (
            <input
                className={`b-filter__radius-input b-filter__input b-filter__radius-input--${placement}`}
                placeholder="+ км"
                name={propName}
                value={this.state[`${propName}.radius`]}
                onChange={(e) => {
                    let value = e.target.value;
                    if (value && value > 500) {
                        value = 500;
                    }
                    this.setState({ [`${propName}.radius`]: value });
                    this.onRadiusInputChange(`${propName}.radius`, value);
                }}
            />
        );
    };

    render() {
        const { filters, filtersOpened, toggleFilter } = this.props;
        const expandCname = cn("b-filter__collapse-btn", {
            "b-filter__collapse-btn--top": filtersOpened,
            "b-filter__collapse-btn--bottom": !filtersOpened,
        });
        const headerTextCname = cn("b-filter__search-text", {
            "b-filter__search-text--dark": filtersOpened,
        });
        const cname = cn("b-filter__body-double-cell--inputs", {
            "b-filter__body-double-cell--inputs-with-button": this.filterValue("from") && this.filterValue("to"),
        });
        return (
            <div className="b-filter">
                <div className="b-filter__head" onClick={toggleFilter}>
                    <div className="b-filter__head--left">
                        {!filtersOpened && <div className="b-filter__search-icon" />}
                        <div className={headerTextCname}>Найти подходящий заказ</div>
                    </div>
                    <div className="b-filter__head--right">
                        {!filtersOpened && (
                            <>
                                {Object.keys(filters).length !== 0 && (
                                    <div className="b-filter__btn b-filter__btn--reset" onClick={this.resetFilters}>
                                        Сбросить
                                    </div>
                                )}
                                <div className="b-filter__btn b-filter__btn--refresh" onClick={this.refreshData}>
                                    Обновить
                                </div>
                            </>
                        )}
                        <div className={expandCname} />
                    </div>
                </div>
                {filtersOpened && (
                    <>
                        <div className="b-filter__body">
                            <div className="b-filter__body-column">
                                <div className="b-filter__body-double-cell">
                                    <div className={cname}>
                                        {this.renderPointSelect("from")}
                                        {this.renderPointSelect("to")}
                                    </div>
                                    {this.filterValue("from") && this.filterValue("to") && (
                                        <div className="b-filter__body-double-cell--button-wrap">
                                            <div
                                                className="b-filter__body-double-cell--button"
                                                onClick={this.swapPoints}
                                            />
                                        </div>
                                    )}
                                </div>
                                {this.renderCounterpartySelect()}
                            </div>
                            <div className="b-filter__body-column">
                                {this.renderLoadDateInput()}
                                {this.renderUnloadDateInput()}
                                {this.renderTrailerTypeSelect()}
                            </div>
                            <div className="b-filter__body-column">
                                {this.renderEmptyMileageInput()}
                                {this.renderOutputWithEmptyMileageConfigInput()}
                                {this.renderTagInputs()}
                            </div>
                        </div>
                        <div className="b-filter__footer">
                            {Object.keys(filters).length !== 0 && (
                                <div className="b-filter__btn b-filter__btn--reset" onClick={this.resetFilters}>
                                    Сбросить
                                </div>
                            )}
                            <div className="b-filter__btn b-filter__btn--refresh" onClick={this.refreshData}>
                                Обновить
                            </div>
                        </div>
                    </>
                )}
            </div>
        );
    }
}
